import React, { useState } from "react";
import { observer } from "mobx-react";
import copilotStore from "Stores/copilotStore";

/**
 * Dedicated website-input card (SG-2182): a text box + "Research" button,
 * the only way Copilot collects a company website for a seller profile.
 * Replaces asking for it via a question_form option (which rendered as a
 * generic answered checklist item, not a clear input, and left room for the
 * model to invent a website when none was actually given). Submitting fires
 * WEBSITE_SUBMITTED and the real research runs directly — the model is not
 * involved in triggering it.
 */
const WebsiteInputBlock = observer(({ block }) => {
  const [website, setWebsite] = useState("");

  if (block.done) {
    return (
      <div className="copilotSellerProfile copilotSellerProfile--done">
        <i className="material-icons-outlined">check_circle</i>
        <span>Website submitted, researching now.</span>
      </div>
    );
  }

  const canSubmit = website.trim().length > 0;
  const submit = () => {
    if (!canSubmit) return;
    copilotStore.submitWebsite(block.id, website);
  };

  return (
    <div className="copilotWebsiteInput">
      <div className="copilotWebsiteInput__head">
        <i className="material-icons-outlined">storefront</i>
        <span>Let's create a seller profile</span>
      </div>
      <div className="copilotWebsiteInput__body">
        <label className="copilotWebsiteInput__label" htmlFor="copilotWebsiteInputField">
          Company website
        </label>
        <div className="copilotWebsiteInput__row">
          <input
            id="copilotWebsiteInputField"
            className="copilotWebsiteInput__field"
            type="text"
            placeholder="https://www.yourcompany.com"
            value={website}
            autoFocus
            onChange={event => setWebsite(event.target.value)}
            onKeyDown={event => {
              if (event.key === "Enter") {
                event.preventDefault();
                submit();
              }
            }}
          />
          <button
            type="button"
            className="copilotWebsiteInput__btn"
            disabled={!canSubmit}
            onClick={submit}
          >
            Research
          </button>
        </div>
      </div>
    </div>
  );
});

export default WebsiteInputBlock;
